import { useState, Suspense, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

// import { Pagination } from "@material-ui/lab";
import { Button } from "@material-ui/core";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { api } from "../../../../utils/api";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import useRouteParam from "../../../../hooks/useRouteParam";
import { LINK } from "../../../../config/config";
import axios from "axios";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/dates";
import { GROUP_LIST } from "../../../../constants/groupList/GroupList";

const ReportGrid = ({ group_number }: { group_number: number }): JSX.Element => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const navigate = useNavigate();
	const queryGroupNumber = useRouteParam("gn");
	const [gridHeight, setGridHeight] = useState("300px");
	const [reportData, setReportData] = useState<any[]>([
		{
			report_type: "Appeal Claims Report",
			description:
				"This report will pull all the empty benefit amount details of the employees of critical illness/whole life plan."
		}
	]);

	// const getReports = useCallback(async () => {
	// 	const JWT_LOC = localStorage.getItem("@jwt");
	// 	const GET_API = `${LINK}/reports/report-log?group_number=220`;

	// 	const response = await axios.get(GET_API, {
	// 		headers: {
	// 			Authorization: `Bearer ${JWT_LOC}`
	// 		}
	// 	});

	// 	const responseData = response.data.result;
	// 	console.log("response --> ", responseData);

	// 	reportData.forEach((data: any) => {
	// 		responseData.forEach((res_data: any) => {
	// 			// datas which are present in both the response and constants
	// 			if (data.report_type === res_data.name) {
	// 				data.last_generated_by =
	// 					res_data.last_generated_first_name + " " + res_data.last_generated_last_name;
	// 				data.last_generated_on = res_data.last_date;
	// 				setReportData(Object.assign([], reportData, { ...data }));
	// 			}
	// 		});
	// 	});
	// }, []);

	const handleRedirectAppealReport = () => {
		navigate(`/idr/generate-report?gn=${group_number}`);
	};

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		const columnIds: any[] = [];
		columnApi?.getAllColumns()?.forEach((column: any) => {
			columnIds.push(column.colId);
		});
		columnApi.autoSizeColumns(columnIds);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
	};

	const handleActionButtonRender = ({
		_isEmployerRoute,
		_queryGroupNumber
	}: {
		_isEmployerRoute: boolean | null;
		_queryGroupNumber: number | null;
	}) => {
		return (
			<Button className="button-red-light rounded-button" variant="outlined" onClick={handleRedirectAppealReport}>
				Generate Report
			</Button>
		);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows()[0];
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleCellValueRender = ({ value }: { value: string }) => {
		return <div>{value ? <div>{value}</div> : <div style={{ marginLeft: 15 }}>N/A</div>}</div>;
	};

	const handleDateCellRenderer = ({ value }: { value: any }) => {
		const date = dateTimeZoneConverter(value as string) as string;
		return <div>{value ? date : "N/A"}</div>;
	};

	// useEffect(() => {
	// 	// console.log("reports state => ", reportData);
	// 	getReports();
	// 	// setDashboardHeader(ADMIN_DASHBOARD_HEADER.data_integrity_report_management);
	// }, [setDashboardHeader, getReports]);

	// useEffect(() => {
	// 	const _gridHeight = getAgGridHeight(reportData.length);
	// 	setGridHeight(_gridHeight);
	// }, [reportData.length]);

	return (
		<div className="group-home-page">
			<div className="group-home-pg-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={reportData}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						onSelectionChanged={handleSelectionChanged}
						frameworkComponents={{
							handleActionButtonRender: handleActionButtonRender,
							handleCellValueRender: handleCellValueRender,
							handleDateCellRenderer: handleDateCellRenderer
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["branding"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="report_type"
							headerName="Report Type"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="description"
							headerName="Description"
							filter={false}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionButtonRender"
							// cellRendererParams={{
							// 	_isEmployerRoute: isEmployerRoute,
							// 	_queryGroupNumber: queryGroupNumber
							// }}
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

export default ReportGrid;
